import React from "react"
import {connect} from "react-redux";
import {bindActionCreators} from "redux";
import YCComponent from "../yc-component";
import LecturerProfile from "./lecturer/profile";
import StudentGroupProfile from "./students/profile";

class Profile extends YCComponent {

    render() {
        switch ( this.props.auth.type ) {
            case "StudentGroup": return <StudentGroupProfile/>;
            case "Lecturer": return <LecturerProfile/>;
            default: return (<div/>);
        }
    }
}


function mapStateToProps(state,ownProps) {
    return {
        auth: state.auth
    };
}

function matchDispatchToProps(dispatch){ return bindActionCreators({}, dispatch); }

export default connect(mapStateToProps, matchDispatchToProps)(Profile);
